import {
  ComponentPropsWithRef,
  ElementType,
  FunctionComponent,
  ReactElement,
  useContext,
} from 'react';

import { Tab as MuiTab, TabProps as MuiTabProps } from '@mui/material';
import clsx from 'clsx';

import { InternalTabsContext } from './InternalTabsContext';
import { WithRef } from '../../../types';

export type TabProps<
  Value extends string = string,
  C extends FunctionComponent | ElementType = 'button'
> = MuiTabProps<C, { component?: C }> & {
  testId?: string;
  value?: Value;
};

export const Tab = (({
  ref,
  className,
  children,
  label,
  testId,
  ...rest
}: WithRef<HTMLDivElement, TabProps<string, any>>) => {
  const { onTabMouseEnter, onTabMouseLeave } = useContext(InternalTabsContext);
  return (
    <MuiTab
      className={clsx('DsTab-Root', className)}
      onMouseEnter={() => onTabMouseEnter(rest.value)}
      onMouseLeave={() => onTabMouseLeave(rest.value)}
      label={<div className="DsTab-Label">{label}</div>}
      ref={ref}
      {...rest}
      data-tabvalue={rest.value}
      data-testid={testId || String(rest.value)}
    >
      {children}
    </MuiTab>
  );
}) as (<
  Value extends string = string,
  C extends FunctionComponent | ElementType = 'button'
>(
  props: TabProps<Value, C> & {
    ref?: ComponentPropsWithRef<C>['ref'];
  }
) => ReactElement) & {
  displayName: string;
};

Tab.displayName = 'Tab';
